export default "__VITE_ASSET__BehSTkyy__"